import React from 'react'
import Box from '@material-ui/core/Box'
import Container from '@material-ui/core/Container'
import { ReactComponent as footerIcon1 } from 'src/mobile/assets/icons/footer_icon1.svg'
import { ReactComponent as footerIcon2 } from 'src/mobile/assets/icons/footer_icon2.svg'
import { ReactComponent as footerIcon3 } from 'src/mobile/assets/icons/footer_icon3.svg'
import { ReactComponent as footerIcon4 } from 'src/mobile/assets/icons/footer_icon4.svg'
import { ReactComponent as footerIcon5 } from 'src/mobile/assets/icons/footer_icon5.svg'
import { ReactComponent as footerIcon6 } from 'src/mobile/assets/icons/footer_icon6.svg'
import { ReactComponent as FooterIcon8 } from 'src/mobile/assets/icons/footer_icon8.svg'
// import { ReactComponent as Totop } from 'src/assets/icons/back_to_top.svg'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import LogoContrast from '../assets/icons/logo_contrast.png'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import {
  CUSTOM_BREAKPOINTS,
  SERVICE_PHONE,
  SERVICE_EMAIL,
  SERVICE_WHATSAPP,
  SITE_MATE_DATA,
} from '../utils/constant'
import { buttonClick } from 'src/utils/trackingCode'

const userStyles = makeStyles((theme) =>
  createStyles({
    root: {
      color: theme.palette.primary.contrastText,
      padding: 0,
    },
    hoverPointer: {
      cursor: 'pointer',
    },
    logo: {
      display: 'block',
      width: theme.spacing(20),
      marginBottom: theme.spacing(5),
      [theme.breakpoints.down(CUSTOM_BREAKPOINTS.md)]: {
        width: theme.spacing(18),
      },
    },
    iconLink: {
      color: theme.palette.primary.contrastText,
      marginRight: theme.spacing(4),
    },
    container: {
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(16),
      paddingBottom: theme.spacing(16),
      backgroundColor: '#11378D',
      display: 'flex',
    },
    contactIcon: {
      fontSize: 16,
    },
    block: {
      display: 'block',
    },
    divider: {
      backgroundColor: theme.palette.background.paper,
      width: theme.spacing(31.25),
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    icon8: {
      marginLeft: theme.spacing(0.5),
      marginTop: theme.spacing(-0.25),
    },
    redBox: {
      width: theme.spacing(0.75),
      height: theme.spacing(0.75),
      backgroundColor: '#F2512D',
      marginRight: theme.spacing(0.5),
    },
  }),
)

const Footer = React.forwardRef((props, ref) => {
  const history = useHistory()
  const classes = userStyles()
  const { t, i18n } = useTranslation()
  const FooterTopText = [
    {
      label: t('glossary.homepage'),
      path: '/',
    },
    {
      label: t('glossary.product_list'),
      path: '/ProductList',
    },
    {
      label: t('glossary. promotion_discount'),
      path: '/promotion',
    },
    {
      label: t('glossary.faq'),
      path: '/faq',
    },
    {
      label: t('glossary.web'),
      path: 'https://take2health.net/',
      icon: FooterIcon8,
      otherWeb: true,
    },
  ]

  const FooterText = [
    {
      label: t('glossary.contact_us'),
      FooterText: [
        {
          label: SERVICE_PHONE,
          icon: footerIcon1,
          toTel: true,
          number:
            SERVICE_PHONE.split(' ')[0].slice(1, 5) +
            SERVICE_PHONE.split(' ')[1] +
            SERVICE_PHONE.split(' ')[2],
        },
        {
          label: SERVICE_WHATSAPP,
          icon: footerIcon2,
          toWhatsApp: true,
          number:
            i18n.language === 'zh-HK'
              ? SITE_MATE_DATA.WHATSAPP_PC_HK
              : i18n.language === 'en'
              ? SITE_MATE_DATA.WHATSAPP_PC_EN
              : SITE_MATE_DATA.WHATSAPP_PC_CN,
        },
        {
          label: SERVICE_EMAIL,
          icon: footerIcon3,
          toMail: true,
        },
      ],
    },
    {
      label: t('glossary.track_us'),
      FooterText: [
        {
          label: 'Facebook',
          icon: footerIcon4,
          openNew: true,
          url: SITE_MATE_DATA.FACEBOOK,
        },
        {
          label: 'Linkedin',
          icon: footerIcon5,
          openNew: true,
          url: SITE_MATE_DATA.LINKEDIN,
        },
        {
          label: 'Youtube',
          icon: footerIcon6,
          openNew: true,
          url: SITE_MATE_DATA.YOUTUBE,
        },
      ],
    },
  ]
  return (
    <Box ref={ref} className={classes.root}>
      {/* <Box bgcolor="white" height={88}>
        <Box textAlign="right">
          <Totop
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: 'smooth',
              })
            }}
          />
        </Box>
      </Box> */}
      <Container className={classes.container} maxWidth="100%">
        <Box mr={5} ml={10.25}>
          <img className={classes.logo} src={LogoContrast} alt="logo" />
        </Box>
        <Box display="flex" ml="auto">
          <Box mr={8}>
            <Box display="flex">
              <Box className={classes.redBox} mt={1} />
              <Box fontWeight={600}>{t('glossary.list_of_websites')}</Box>
            </Box>
            {FooterTopText.map((item, index) => (
              <Box
                key={index}
                mt={3}
                fontWeight={600}
                fontSize={18}
                onClick={() => {
                  item.path === 'https://take2health.net/' &&
                    buttonClick('EH_Footer_CorpSite', 'EH_Footer_CorpSite')
                  item.otherWeb ? window.open(item.path) : history.push(`/${i18n.language}${item.path}`)
                }}
                className={classes.hoverPointer}
              >
                {item.icon ? (
                  <Box display="flex">
                    <Box>{item.label}</Box>
                    <item.icon className={classes.icon8} />
                  </Box>
                ) : (
                  <Box mt={2.5}>{item.label}</Box>
                )}
              </Box>
            ))}
          </Box>
          <Box display="flex" mt={-3}>
            {FooterText?.map((item, index) => (
              <Box key={index} className={classes.list} mr={8}>
                <Box display="flex">
                  <Box className={classes.redBox} mt={3.75} />
                  <Box mt={3} fontWeight={600} fontSize={14}>
                    {item.label}
                  </Box>
                </Box>
                <Box>
                  {item?.FooterText?.map((item, index) => (
                    <Box
                      className={classes.hoverPointer}
                      key={index}
                      mt={3}
                      display="flex"
                      onClick={() => {
                        const buttonName = item?.toTel
                          ? 'EH_Footer_Phone'
                          : item?.toWhatsApp
                          ? 'EH_Footer_WhatsApp'
                          : item?.toMail
                          ? 'EH_Footer_email'
                          : ''
                        const buttonId = item?.toTel
                          ? 'EH_Footer_Phone'
                          : item?.toWhatsApp
                          ? 'EH_Footer_WhatsApp'
                          : item?.toMail
                          ? 'EH_Footer_email'
                          : ''
                        buttonClick(buttonName, buttonId)
                        item.openNew
                          ? window.open(item.url)
                          : item.toTel
                          ? (window.location.href = `tel:${item.number}`)
                          : item.toWhatsApp
                          ? (window.location.href = item.number)
                          : (window.location.href = `mailto:${item.label}`)
                      }}
                    >
                      <item.icon />
                      <Box ml={1} mt={0.6} fontSize={16}>
                        {' '}
                        {item.label}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  )
})

export default Footer
